import { render, staticRenderFns } from "./ClubTab.vue?vue&type=template&id=e8ab43d8&scoped=true"
import script from "./ClubTab.vue?vue&type=script&lang=js"
export * from "./ClubTab.vue?vue&type=script&lang=js"
import style0 from "./ClubTab.vue?vue&type=style&index=0&id=e8ab43d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ab43d8",
  null
  
)

export default component.exports